import { Hr } from './Hr/Hr';
import { IAppModules } from './interfaces';

export const modules: IAppModules[] = [
    new Hr({}),
];
